const prefix = '@@seat-selection-integration-workflow';

const SET_VIEW_BOX = `${prefix}/SET_VIEW_BOX`;
const SET_REFERENCE_IMAGE = `${prefix}/SET_REFERENCE_IMAGE`;
const TOGGLE_REFERENCE_IMAGE = `${prefix}/TOGGLE_REFERENCE_IMAGE`;
const HOVER_SEAT = `${prefix}/HOVER_SEAT`;
const SET_TICKET_PURCHASE_DIALOG = `${prefix}/SET_TICKET_PURCHASE_DIALOG`;
const MOUSE_DRAG = `${prefix}/MOUSE_DRAG`;
const MOUSE_DOWN = `${prefix}/MOUSE_DOWN`;
const MOUSE_UP = `${prefix}/MOUSE_UP`;
const MOUSE_MOVE = `${prefix}/MOUSE_MOVE`;
const KEY_UP = `${prefix}/KEY_UP`;
const KEY_DOWN = `${prefix}/KEY_DOWN`;
const SELECT_SEATING = `${prefix}/SELECT_SEATING`;
const CREATE_NOTIFICATION = `${prefix}/CREATE_NOTIFICATION`;
const DELETE_NOTIFICATION = `${prefix}/DELETE_NOTIFICATION`;
const SET_WAITING_HALL_UPDATE = `${prefix}/WAITING_HALL_UPDATE`;
const ZOOM_VIEW_BOX = `${prefix}/ZOOM_VIEW_BOX`;
const MOUSE_CLICK_KEYBOARD_KEY = `${prefix}/MOUSE_CLICK_KEYBOARD_KEY`;
const SET_VIEW_BOX_SLIDER = `${prefix}/SET_VIEW_BOX_SLIDER`;
const FOCUS_ON_TICKET_TYPE = `${prefix}/FOCUS_ON_TICKET_TYPE`;
const OUT_OF_FOCUS_TICKET_TYPE = `${prefix}/OUT_OF_FOCUS_TICKET_TYPE`;
const SET_TICKET_TYPES = `${prefix}/SET_TICKET_TYPES`;

const SET_RESERVED_TICKET_TYPE_FOR_SEATS = `${prefix}/SET_RESERVED_TICKET_TYPE_FOR_SEATS`;

const SET_DISCARDED_TICKET_TYPE_FOR_SEATS = `${prefix}/SET_DISCARDED_TICKET_TYPE_FOR_SEATS`;
export {
    HOVER_SEAT,
    SET_VIEW_BOX,
    SET_REFERENCE_IMAGE,
    TOGGLE_REFERENCE_IMAGE,
    CREATE_NOTIFICATION,
    SET_TICKET_PURCHASE_DIALOG,
    MOUSE_DRAG,
    MOUSE_DOWN,
    MOUSE_UP,
    KEY_UP,
    KEY_DOWN,
    SELECT_SEATING,
    DELETE_NOTIFICATION,
    SET_WAITING_HALL_UPDATE,
    MOUSE_MOVE,
    ZOOM_VIEW_BOX,
    MOUSE_CLICK_KEYBOARD_KEY,
    SET_VIEW_BOX_SLIDER,
    FOCUS_ON_TICKET_TYPE,
    OUT_OF_FOCUS_TICKET_TYPE,
    SET_TICKET_TYPES,
    SET_RESERVED_TICKET_TYPE_FOR_SEATS,
    SET_DISCARDED_TICKET_TYPE_FOR_SEATS,
};
